import {
  components as clientComponents,
  selectors as clientSelectors
} from 'mage-client'
import { selectors as coreSelectors } from 'mage-core'
import { thunks as stateThunks } from 'mage-state'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import AccessDenied from './AccessDenied'

const { CapabilitiesContext } = clientComponents

const returnNull = R.always(null)

const hasAccess = (desired, capabilities) => {
  const des = R.pipe(
    R.map(R.prop('KEY')),
    R.values()
  )(desired)
  const caps = R.keys(capabilities)

  return R.any(d => R.contains(d, caps), des)
}

const CapabilitiesProvider = ({
  capabilities,
  children,
  clientId,
  desired,
  error,
  ErrorComponent,
  getCapabilities,
  isLoading,
  LoadingComponent,
  options
}) => {
  useEffect(() => {
    getCapabilities({ ...options, params: { ...options.params, clientId } })
  }, [])

  if (isLoading) {
    return <LoadingComponent />
  } else if (error) {
    return <ErrorComponent />
  } else if (!hasAccess(desired, capabilities)) {
    return <AccessDenied />
  } else {
    return (
      <CapabilitiesContext.Provider value={capabilities}>
        {React.Children.only(children)}
      </CapabilitiesContext.Provider>
    )
  }
}

CapabilitiesProvider.propTypes = {
  capabilities: PropTypes.object,
  children: PropTypes.node.isRequired,
  clientId: PropTypes.string,
  desired: PropTypes.object,
  error: PropTypes.object,
  ErrorComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  getCapabilities: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  LoadingComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  options: PropTypes.object
}

CapabilitiesProvider.defaultProps = {
  capabilities: {},
  desired: {},
  error: null,
  ErrorComponent: returnNull,
  isLoading: false,
  LoadingComponent: returnNull,
  options: {}
}

export default R.compose(
  connect(
    state => ({
      isLoading: clientSelectors.isCapabilitiesLoading(state),
      error: clientSelectors.getCapabilitiesError(state),
      capabilities: clientSelectors.getCapabilities(state),
      clientId: coreSelectors.clientId(state)
    }),
    {
      getCapabilities: stateThunks.fetchCapabilities
    }
  )
)(CapabilitiesProvider)

export { CapabilitiesProvider, CapabilitiesContext }
